<template>
  <div>

    <div class="col-md-4 text-center mx-auto">
      <h3 v-if="getPartner">Seja bem-vindo(a)!</h3>
      <h3 v-else>Seja bem-vindo(a) à Brobot Platform!</h3>
      <p>Para darmos continuidade ao processo de cadastro, precisamos que você informe o seu nome completo, email e a senha que você deseja utilizar</p>
    </div>

    <div class="col-md-3 mx-auto pt-5">

      <div class="row">
        <div class="form-group col-md-12">
          <label for="name">Nome</label>
          <input v-model="name" :class="{ 'field-with-error': errorName }" type="text" class="form-control" id="name">
        </div>

        <div class="form-group col-md-12">
          <label for="email">E-mail</label>
          <input v-model="email" type="email"
                 :class="{ 'field-with-error': errorEmail }"
                 autocomplete="new-password"
                 class="form-control" ref="email" id="email">

          <p v-if="exitingEmail">E-mail já está em uso.
            <router-link to="/login"> Já possui uma conta? Faça login aqui.</router-link>
            <strong style="cursor: pointer" @click="exitingEmail=false">X</strong>
          </p>
        </div>

        <div class="form-group col-md-12">
          <label for="password">Senha</label>
          <input v-model="password" :class="{ 'field-with-error': errorPassword }"
                 autocomplete="new-password"
                 type="password" class="form-control" id="password">
        </div>
      </div>

      <button :disabled="checkFields" @click="register" class="btn btn-primary btn-block">Próximo Passo</button>

    </div>

  </div>
</template>

<script>
  import GetPartner from '@/mixins/GetPartner'

  export default {
    computed: {
      checkFields() {
        let inputEmail = this.$refs.email
        if (this.name && this.email && this.password && inputEmail)
          return !inputEmail.checkValidity()
        else
          return true
      },
      errorEmail() {
        if (!this.email.length)
          return false
        else
          return !this.$refs.email.checkValidity()
      }
    },
    data() {
      return {
        email: '',
        errorName: false,
        errorPassword: false,
        exitingEmail: false,
        name: '',
        password: ''
      }
    },
    methods: {
      handleErrors(errors, data) {
        if (data.password)
          this.errorPassword = true

        let index = errors.findIndex((message) => message === 'E-mail já está em uso')
        if (index >= 0) {
          errors.splice(index, 1)
          this.exitingEmail = true
        }

        if (errors.length === 0)
          return

        errors.forEach(error => this.$notify.addError(error))
      },
      register() {
        let user = { email: this.email, name: this.name, password: this.password }
        this.axios.post('auth', user )
          .then(resp => this.$emit('createUser', resp.data))
          .catch(e => {
            try {
              this.handleErrors(e.errors, e.data)
            } catch (err) {
              this.$notify.addError(e)
            }
          })
      }
    },
    mixins: [GetPartner],
    name: 'Register',
    watch: {
      name() {
        this.errorName = false
      },
      password() {
        this.errorPassword = false
      }
    }
  }
</script>

<style scoped>

  .field-with-error {
    border: 2px red solid ;
  }

</style>
